import { ClientComplaints } from "./types/complaints";

export const defaultClientComplaint: ClientComplaints = {
    clientId: '',
    description: '',
    type: 0
}